(ns common.fields.ui-modules)

(defonce company-modules [:company-module/heading
                          :company-module/guests
                          :company-module/basic-details
                          :company-module/online-presence
                          :company-module/address
                          :company-module/key-people
                          :company-module/business-overview
                          :company-module/documents
                          :company-module/other
                          :company-module/financials])

(defonce oppo-modules [:deal-module/heading
                       :deal-module/guests
                       :deal-module/basic-information
                       :deal-module/deal-details
                       :deal-module/lead-details
                       :deal-module/transaction
                       :deal-module/tags
                       :deal-module/other
                       :deal-module/opportunity-details
                       :deal-module/co-operation-details
                       :deal-module/deal-sheet-summary
                       :deal-module/opportunity-overview
                       :deal-module/deal-rating
                       :deal-module/attachments])

(defonce person-modules [])

(defonce fund-modules [])

(defonce ui-modules
  (concat company-modules
          oppo-modules
          person-modules
          fund-modules))
